import type { QuickStepsConfig } from '../store/schema/QuickStepsConfig';

const CURRENT_QUICKSTEP_VERSION = 0;

export const defaultConfig: QuickStepsConfig = {
    version: CURRENT_QUICKSTEP_VERSION,
    // TODO 145566 add default quick steps
    // This is test data for now, once we add saving this should be removed
    quickSteps: [
        {
            id: 'Test1Id',
            name: 'Test1 unread',
            description: 'Testing description',
            iconId: 'markAsUnread',
            actions: [{ type: 'markAsUnread' }],
        },
        {
            id: 'Test2Id',
            name: 'Test2 read',
            description: 'Testing description 2',
            iconId: 'markAsRead',
            actions: [{ type: 'markAsRead' }],
        },
        {
            id: 'Test3Id',
            name: 'Test3 delete',
            description: 'Testing description',
            iconId: 'delete',
            actions: [{ type: 'delete' }],
        },
    ],
};
